import * as React from 'react';
import { RequestAppointmentForm } from './RequestAppointmentForm';
import { useRequestAppointment } from '../lib/useRequestAppointment';
import { CircleCheck } from 'lucide-react';
import { Button } from 'src/shadcn/components/ui/button';

export interface IRequestAppointmentBodyProps {}

export const RequestAppointmentBody: React.FunctionComponent<
  IRequestAppointmentBodyProps
> = props => {
  const { onRequestAppointment, loading } = useRequestAppointment();
  const [requestSuccessful, setRequestSuccessful] = React.useState(false);
  return (
    <>
      <div className={'m-auto max-w-4xl px-5 py-20 md:px-0'}>
        {requestSuccessful && (
          <div className='flex flex-col items-center'>
            <CircleCheck className='size-8' />
            <h1 className='text-2xl font-semibold'>
              Appointment request was submitted
            </h1>
            <p className='mt-10 max-w-2xl text-center'>
              Please give our team some time to view your request. Look out for
              a text message or phone call from our team confirming your
              appointment. See you at the shop soon!
            </p>
            <Button
              variant={'outline'}
              className='mt-10'
              onClick={() => {
                setRequestSuccessful(false);
              }}
            >
              <span>Request another appointment</span>
            </Button>
          </div>
        )}

        {!requestSuccessful && (
          <>
            <h1 className={'pb-10 text-2xl font-semibold'}>
              Request appointment form
            </h1>
            <RequestAppointmentForm
              onRequestAppointment={onRequestAppointment}
              isRequestingAppointment={loading}
              onRequestSuccessful={() => setRequestSuccessful(true)}
            />
          </>
        )}
      </div>
    </>
  );
};
